import CourseCatalog from "./Courses/All_Courses";
import CourseReviews from "./Courses/Course_Review";

import "./Css/Courses.css";
import StaticData from "./Courses/Static_Data";

function Courses() {
  return (
    <div>
      <CourseCatalog />
      <StaticData />
      <CourseReviews />
    </div>
  );
}

export default Courses;
